import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Table, message } from "antd";
import { useEffect, useState } from "react";
import "../../App.css";
import CategoryFormModal from "../../components/Configuration/CategoryFormModal";
import Header from "../../components/Header";
import {
  createProductCategory,
  getProductCategories,
  updateProductCategory,
} from "../../repository/categoriesApi";

const Categories = () => {
  const [productCategories, setProductCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
 const auth = JSON.parse(localStorage.getItem("auth"));
  useEffect(() => {
    fetchProductCategories();
  }, []);

  const fetchProductCategories = async () => {
    try {
      const data = await getProductCategories();
      setProductCategories(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreate = async (values) => {
    try {

      const payload = {
        ...values,
        org: auth?.org,
      };

      // const newCategory = await createProductCategory(values);
      const newCategory = await createProductCategory(payload);
      message.success("Category created successfully");
      setProductCategories((prev) => [...prev, newCategory]); // ✅ add new item locally
      setIsModalOpen(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to create category");
    }
  };

  const handleEdit = async (values) => {
    try {

      const payload = {
        ...values, 
        org: auth.org, 
      };

      const updatedCategory = await updateProductCategory(
        editingCategory.id,
       payload
      );
      message.success("Category updated successfully");

      // ✅ replace the updated category locally
      setProductCategories((prev) =>
        prev.map((cat) =>
          cat.id === editingCategory.id ? { ...cat, ...updatedCategory } : cat
        )
      );

      setEditingCategory(null);
      setIsModalOpen(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to update category");
    }
  };

  const handleDelete = async (id) => {
    try {
      await updateProductCategory(id, { is_archive: true });
      message.success("Category archived successfully");

      // ✅ remove it from local state
      setProductCategories((prev) => prev.filter((cat) => cat.id !== id));
    } catch (err) {
      console.error(err);
      message.error("Failed to archive category");
    }
  };

  const columns = [
    {
      title: "Category Name",
      dataIndex: "CategoryName",
      key: "categoryName",
    },
    {
      title: "Parent Category",
      dataIndex: "PartentCategory",
      key: "parentCategory",
    },
    {
      title: "Income Account",
      dataIndex: "IncomeAccount",
      key: "incomeAccount",
      render: (account) => account?.AccountName || "-",
    },
    {
      title: "Expense Account",
      dataIndex: "ExpenseAccount",
      key: "expenseAccount",
      render: (account) => account?.AccountName || "-",
    },

    {
      title: "Actions",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="primary"
            icon={<EditOutlined />}
            size="small"
            onClick={() => {
              setEditingCategory(record);
              setIsModalOpen(true);
            }}
          />

          <Popconfirm
            title="Are you sure to delete this category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger icon={<DeleteOutlined />} size="small" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      <Header />

      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
        <div className="row">
          <div className="col-6">
            <h1 className="text-2xl font-bold">Categories</h1>
          </div>
          <div className="col-6">
            <Button
              type="primary"
              className="xb"
              icon={<PlusOutlined />}
              style={{ float: "right" }}
              onClick={() => {
                setEditingCategory(null);
                setIsModalOpen(true);
              }}
            >
              Add Category
            </Button>
          </div>
        </div>

        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table
              columns={columns}
              dataSource={productCategories}
              rowKey="id"
            />
          </div>
        </div>

        <CategoryFormModal
          visible={isModalOpen}
          initialValues={editingCategory}
          onCancel={() => setIsModalOpen(false)}
          onSubmit={editingCategory ? handleEdit : handleCreate}
        />
      </div>
    </div>
  );
};

export default Categories;
